import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M9 0C4.029 0 0 4.029 0 9s4.029 9 9 9 9-4.029 9-9-4.029-9-9-9zm-.001 14.5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5zm2.223-5.958l-1.148 1.147c-.174.175-.174.24-.174.322V11H8.1v-.989c0-.798.4-1.292.7-1.594l1.15-1.148c.311-.31.447-.741.374-1.184a1.34 1.34 0 0 0-2.17-.807 1.335 1.335 0 0 0-.497 1.041h-1.8c0-.95.423-1.839 1.161-2.438a3.166 3.166 0 0 1 2.648-.635A3.136 3.136 0 0 1 12.1 5.793a3.124 3.124 0 0 1-.878 2.749z" />
  </svg>
);

export default SvgComponent;
